module.exports = __webpack_public_path__ + "static/img/appstore.c7439a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appstore.png
// module id = Rf8H
// module chunks = 0